import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { withSnackbar } from 'notistack';

import ApiManager from '../../../Api/ApiManager';
import APIManagerV2 from "../../../Api/APIManagerV2";

class SharedSnackbarContent extends Component {
  constructor(props) {
    super(props);
    ApiManager.SNACKBAR_PROVIDER = this;
  }

  /**
   * Opens the snackbar with a message and a certain style depending on its status.
   *
   * @method openSnackbar
   * @param {string} status - Status influences snackbar color:
   *   'error' (red), 'success' (green), 'info' (blue), 'warning' (yellow)
   * @param {string} message - Message is displayed on snackbar
   */
  openSnackbar = (status, res, override) => {
    const { intl, enqueueSnackbar } = this.props;
    const defaultMessage = (res && res.status) ? `Could not retrieve data: Error ${res.status}` : `${res}`;
    const id = status === 'success' ? 'api.success' : ((res && res.status) ? 'api.error' : 'api.noStatus');
    let snackMessage = intl.formatMessage({
      id,
      defaultMessage,
    }, { status: res.status ? res.status : 0 });
    let snackOptions = {
      variant: status,
      autoHideDuration: status === 'success' ? 1000 : 5000,
    };

    if (override) {
      const { successText, failText, snackbarProps } = override;
      if(status === 'success' && successText) {
        snackMessage = successText;
      } else if(failText) {
        snackMessage = failText;
      }
      snackOptions = {
        variant: status,
        ...snackbarProps,
      };
    }
    enqueueSnackbar(snackMessage, snackOptions);
  };

  render() {
    const { children } = this.props;
    return (
      <React.Fragment>
        {children}
      </React.Fragment>
    );
  }
}

SharedSnackbarContent.propTypes = {
  children: PropTypes.node.isRequired,
  enqueueSnackbar: PropTypes.func.isRequired,
};

export default injectIntl(withSnackbar(SharedSnackbarContent));
